import { useSequenceState } from './motion.jsx';
import { revealState } from '../../hooks/useReveal.js';
import styles from './SpecList.module.css';

/**
 * The specification table on a project page. Each row's cascade index is
 * passed down as a custom property, so the list can grow without the
 * hand-written run of :nth-child rules the stylesheet used to need.
 */
export function SpecList({ specs }) {
  const { shown } = useSequenceState();

  return (
    <dl className={styles.list}>
      {specs.map(({ label, value }, i) => (
        <div
          key={label}
          className={styles.row}
          style={{ '--i': i }}
          data-spec-row={revealState(shown)}
        >
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
}
